import { Injectable, inject } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {WebHookEnvioModel} from '../model/webhookEnvio-model';
import {WebhookModel} from '../model/webhook-model';

@Injectable({
  providedIn: 'root'
})
export class WebhookService {

  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}/webhook`



  buscarWebhook(): Observable<WebhookModel>{
    return this.http.get<WebhookModel>(this.urlBase);
  }

  gerarNovoToken(webHook: WebhookModel){
    return this.http.post<WebHookEnvioModel>(`${this.urlBase}/gerar-token`, webHook);
  }

  salvarWebHook(webHook: WebhookModel): Observable<WebHookEnvioModel> {
    return this.http.post<WebHookEnvioModel>(this.urlBase, webHook);
  }

}
